/* =========================================================================
   Die Hoehe des Fusses an die Bildebene weitergeben.

   WARUM ES DAS BRAUCHT:
   Das Pflanzenbild soll den ganzen Fuss ausfuellen. Der Fuss besteht aber
   aus ZWEI Sektionen — unserem Kopf und Mottos Fuss —, und die haben
   keinen gemeinsamen Rahmen, an dem sich eine Ebene mit `height: 100%`
   festhalten koennte.

   WARUM NICHT AM `body`:
   Ein Hintergrundbild am Body wird am FENSTER ausgerichtet, nicht am
   Seitenende. `background-position: bottom` heisst dort „unten im
   Fenster", und das Bild lag damit auch oben unter dem Header. Auf der
   Konfiguratorseite, wo der Kopfbereich durchsichtig ist, sah man es.
   Nachgemessen und im Bild gesehen.

   WAS ES TUT:
   Misst die Hoehe aller Sektionen der Fussgruppe zusammen und schreibt sie
   als `--ug-fusshoehe`. Die Bildebene liegt absolut im Kopf und ist genau
   so hoch.
   ========================================================================= */
(function () {
  'use strict';

  function messen() {
    const teile = document.querySelectorAll('.shopify-section-group-footer-group');
    if (!teile.length) return;

    let hoehe = 0;
    teile.forEach((t) => { hoehe += t.getBoundingClientRect().height; });
    if (hoehe > 0) {
      document.documentElement.style.setProperty('--ug-fusshoehe', Math.ceil(hoehe) + 'px');
    }
  }

  messen();
  window.addEventListener('load', messen);
  window.addEventListener('resize', messen);

  /* Der Fuss wird hoeher, wenn Bilder nachladen oder das Menue aufklappt.
     Ein Beobachter ist billiger als ein Zeitgeber und genauer als beides. */
  if (typeof ResizeObserver === 'function') {
    const beobachter = new ResizeObserver(messen);
    document.querySelectorAll('.shopify-section-group-footer-group')
      .forEach((t) => beobachter.observe(t));
  }
})();
